//===========My Account========//
var _url = window.location;
if (_url.pathname === '/account') {
    if (_url.hash === '#orders') {
        $('._orders').addClass('_active');
        $('._information').removeClass('_active');
        $('._adresses').removeClass('_active');
        $('._account_orders').removeClass('_hide');
        $('._account_info').addClass('_hide');
        $('._account_adresses').addClass('._hide');
    }
}

$('._information').on('click', function() {
    if ($('._information').hasClass('_active')) { return }
    $('._information').addClass('_active');
    $('._orders').removeClass('_active');
    $('._adresses').removeClass('_active');
    $('._account_info').removeClass('_hide');
    $('._account_orders').addClass('_hide');
    $('._account_adresses').addClass('._hide');
    $('.full-adress').removeClass('hide');
});
$('._orders').on('click', function() {
    if ($('._orders').hasClass('_active')) { return }
    $('._orders').addClass('_active');
    $('._information').removeClass('_active');
    $('._adresses').removeClass('_active');
    $('._account_orders').removeClass('_hide');
    $('._account_info').addClass('_hide');
    $('._account_adresses').addClass('._hide');
    $('.full-adress').addClass('hide');
});

function registerSuccessFr(){
    alert("Merci d’avoir compléter votre inscription. Votre compte est activé. Continuez de magasiner!");
}
function registerSuccessEn(){
    alert("Thank you for completing your registration. Your account is activated. Keep shopping!");
}
//=========== End My Account========//

/*page cms adress*/
$('._adresses').on('click', function() {
    if ($('._adresses').hasClass('_active')) { return }
    $('._adresses').addClass('_active');
    $('._orders').removeClass('_active');
    $('._information').removeClass('_active');
    $('._account_adresses').removeClass('_hide');
    $('._account_orders').addClass('_hide');
    $('._account_info').addClass('_hide');
});
$('#AddressNewButton').on('click', function() {
    $('.my-adresses-no-adresses').addClass('_hide');
});
$('.address-new-toggle2').on('click', function() {
    $('.my-adresses-no-adresses').removeClass('_hide');
    $('#AddressNewForm').addClass('_hide');

});
/**/
/*page cms career*/
$('.carr-icon-p').on('click', function (){
    $('.carr-menu-jobs').removeClass('_hide');
    $('.carr-menu-jobs').addClass('_active');
    $('.carr-icon-p').addClass('_hide');
    $('.carr-icon-m').removeClass('_hide');
});$('.carr-icon-m').on('click', function (){
    $('.carr-menu-jobs').removeClass('_active');
    $('.carr-menu-jobs').addClass('_hide');
    $('.carr-icon-p').removeClass('_hide');
    $('.carr-icon-m').addClass('_hide');
});

/* pdp */
$('.p-quantity .p-minus').on('click', function () {
    var input_q = $('.p-quantity input').val();
    input_q = parseInt(input_q) - 1;
    if (input_q<=0 || !input_q) input_q = 1;
    $('.p-quantity input').val(input_q);
});
$('.p-quantity .p-plus').on('click', function () {
    var input_q = $('.p-quantity input').val();
    input_q = parseInt(input_q) + 1;
    if (input_q<=0 || !input_q) input_q = 1;
    $('.p-quantity input').val(input_q);
});

$('.pdp__descriptions .psd-title').on('click', function() {

    if($(this).parent().hasClass('show')) {
        $(this).next().slideUp();
    } else {
        $(this).next().slideDown();
    }

    $(this).parent().toggleClass('show');
});

$('.product-single__thumbnails').on('click', function() {
    $('.pdp-product-images-slide-wrap').addClass('show');
});
$('.pdp-slider-close').on('click', function() {
    $('.pdp-product-images-slide-wrap').removeClass('show');
});

/**/

var butoon_prev = '<button aria-label="prev" class="sc-prev"><span class="hidden">prev</span><svg width="20px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><polygon id="path-1" points="0 0 17.7039161 0 17.7039161 19.7096452 0 19.7096452"></polygon></defs><g id="HP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP-test" transform="translate(-60.000000, -552.000000)"><g id="Group-3" transform="translate(70.000000, 561.000000) scale(1, -1) rotate(-270.000000) translate(-70.000000, -561.000000) translate(61.000000, 551.000000)"><g id="Clip-2"></g><path d="M8.84655,-3.22580645e-05 C8.30012143,-3.22580645e-05 7.88226429,0.419322581 7.88226429,0.967709677 L7.88226429,16.6773871 L1.58226429,11.2580323 C1.16440714,10.9031935 0.553692857,10.9677097 0.232264286,11.3548065 C-0.121307143,11.7741613 -0.0570214286,12.3870645 0.328692857,12.7096452 L8.20369286,19.4838387 C8.39655,19.645129 8.62155,19.7096452 8.84655,19.7096452 C9.07155,19.7096452 9.29655,19.645129 9.48940714,19.4838387 L17.3644071,12.7096452 C17.7822643,12.3548065 17.8144071,11.7419032 17.4608357,11.3548065 C17.1072643,10.9354516 16.49655,10.9031935 16.1108357,11.2580323 L9.81083571,16.6773871 L9.81083571,0.967709677 C9.81083571,0.419322581 9.39297857,-3.22580645e-05 8.84655,-3.22580645e-05" id="Fill-1" fill="#000000"></path> </g></g></g></svg></button>';
var button_next = '<button aria-label="next" class="sc-next"><span class="hidden">next</span><svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" width="20" height="18"><defs><clipPath clipPathUnits="userSpaceOnUse" id="cp1"><path d="M0.29 0.3L0.29 18L20 18L20 0.29L0.29 0.3Z" /></clipPath></defs><style>tspan { white-space:pre } .shp0 { fill: #000000 } </style> <g id="HP"> <g id="HP-test"> <g id="Group-3"> <g id="Clip-2"> </g> <g id="Clip-Path: Fill-1" clip-path="url(#cp1)"> <path id="Fill-1" fill-rule="evenodd" class="shp0" d="M0.29 9.15C0.29 8.6 0.71 8.18 1.26 8.18L16.97 8.18L11.55 1.88C11.19 1.46 11.26 0.85 11.64 0.53C12.06 0.17 12.67 0.24 13 0.62L19.77 8.5C19.94 8.69 20 8.91 20 9.14C20 9.36 19.94 9.59 19.77 9.78L13 17.66C12.65 18.08 12.03 18.11 11.65 17.76C11.23 17.4 11.2 16.79 11.55 16.41L16.97 10.1L1.26 10.11C0.71 10.11 0.29 9.69 0.29 9.15Z" /> </g> </g> </g> </g></svg></button>';

$(document).ready(function() {
    var lang = spotDefault.spotDOM.locale();

        setTimeout(function(){
            if ($('.sc-slider').length !== 0) {
                $('.sc-slider').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    prevArrow: butoon_prev,
                    nextArrow: button_next,
                    responsive: [
                        {
                            breakpoint: 749,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });

                if (window.wishlistInitialize) {
                    window.wishlistInitialize();
                }
            }
        }, 700);

    if ($('.pdp-product-images-slide').length !== 0) {
        $('.pdp-product-images-slide').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
            adaptiveHeight: true,
            prevArrow: butoon_prev,
            nextArrow: button_next,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                        variableWidth: false,
                        centerMode: false,
                        adaptiveHeight: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }



    $('.address-edit-toggle').on('click', function(){
        $('.address').addClass('hide');
        $('.form-edit-myaddress').removeClass('hide');
    });
    $('.my-adresses-bouton-annuler').on('click', function(){
        $('.address').removeClass('hide');
        $('.form-edit-myaddress').addClass('hide');
    });

    $('.plp-open-filters-mobile').on('click', function(){
        $('.plp-spot-filters .pane.horizontal .facets').addClass('open');
        $('#PageContainer').css('z-index', '21');
        if ($('.plp-voir-produits').length === 0) {
            $('.facets').append("<div class='plp-voir-produits'><button class='btn'>"+
              (lang === 'fr' ? 'Voir le produits' : 'View product') +
              "</button></div>") }
    });
    $('.plp-section-right').on('click', '.close-all-facets', function(){
        $('.plp-spot-filters .pane.horizontal .facets').removeClass('open');
        $('#PageContainer').css('z-index', 'initial');
    });
    $('.plp-section-right').on('click', '.plp-voir-produits button', function(){
        $('.plp-spot-filters .pane.horizontal .facets').removeClass('open');
        $('#PageContainer').css('z-index', 'initial');
    });

    /* store locator */


    $('#bh-sl-map-container').on('click', '.scasl-horaire', function () {
        const d = new Date();
        let day = d.getDay();
        $(this).next().toggleClass('hide');
        $(this).next().find('.horaire-ouverture>span').eq(--day).css('font-weight', 'bold');

    });


    /* end store locator */
    /* Eyes Show and Hide password Login and Register page */
    $("#show_hide_password a").on('click', function(event) {
        event.preventDefault();
        if($('#show_hide_password input').attr("type") == "text"){
            $('#show_hide_password input').attr('type', 'password');
            $('.see-pass').removeClass( "hide" );
            $('.hide-pass').addClass( "hide" );
        }else if($('#show_hide_password input').attr("type") == "password"){
            $('#show_hide_password input').attr('type', 'text');
            $('.see-pass').addClass( "hide" );
            $('.hide-pass').removeClass( "hide" );
        }
    });


    /*
    $("#show_hide_password a").on('click', function(event) {
        event.preventDefault();
        if($('#show_hide_password input').attr("type") == "text"){
            $('#show_hide_password input').attr('type', 'password');
            $('#show_hide_password i').addClass( "fa-eye-slash" );
            $('#show_hide_password i').removeClass( "fa-eye" );
        }else if($('#show_hide_password input').attr("type") == "password"){
            $('#show_hide_password input').attr('type', 'text');
            $('#show_hide_password i').removeClass( "fa-eye-slash" );
            $('#show_hide_password i').addClass( "fa-eye" );
        }
    });*/
    /* end Eyes */

});




